export default "__VITE_ASSET__adade0a4__"